import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__network } from './STATE__network';

export const local_network_set_avg_server_latency = (payload: number): PayloadAction<number> => ({
  type: ENUM__redux_action.NETWORK_SET_AVG_SERVER_LATENCY,
  payload,
});

export const init_local_network_set_avg_server_latency = (state: STATE__network, action: PayloadAction<number>) => {
  state.avg_server_latency = action.payload;
};
